import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownUserRelationTypes = ( { control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, relationshipType} ) =>
{
    const [ loading, items ] = useListboxFetch( { url: '/users/relationtypes?grouping=' + relationshipType, keyFieldName: 'ar_type_id', labelFieldName: 'name', additionalFields: [] } ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownUserRelationTypes;
